import { atom } from "recoil";

export const staffAddModalStore = atom({
	key: "staffAddModalStore",
	default: {
		show: false,
		stage: "form",
		form: {
			login: "",
			password: "",
			level: "",
			brandIds: [],
			defaultGroupIds: [],
			tfa: true,
		},
		groups: [],
		groupsLoaded: false,
		groupsError: null,
		visibleProjects: [],
		visibleProjectsLoaded: false,
		visibleProjectsError: "",
		visibleProjectsLogin: "",
		result: {
			secret: null,
			brands: [],
		},
		error: { text: "", code: 0, timestamp: 0 },
	},
});
